var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8259 18.3521C11.4181 19.0002 12.2693 19.4076 13.2131 19.4076C15.0082 19.4076 16.4517 17.9632 16.4517 16.1669C16.4517 15.2965 16.0815 14.4632 15.4523 13.8706C14.6381 13.0928 13.4537 12.9817 12.4544 12.5743C11.3811 12.1298 10.5298 11.2595 10.5298 10.0187C10.5298 8.40762 11.8437 7.11133 13.4352 7.11133C14.231 7.11133 14.9712 7.44466 15.4893 7.96318",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4536 7.09281V5.11133",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4536 21.9074V19.5",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.925293 13.4999C0.925293 12.0369 1.18437 10.611 1.64702 9.29615C3.36806 4.42578 8.03153 0.925781 13.4907 0.925781C17.0994 0.925781 20.3749 2.46282 22.6696 4.90726",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.925293 13.4814C0.925293 14.5555 1.05483 15.5926 1.31392 16.574",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0747 13.5183C26.0747 12.4257 25.9451 11.4072 25.686 10.4072",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0748 13.4814C26.0748 20.4259 20.449 26.0555 13.5093 26.0555C10.0487 26.0555 6.92124 24.6481 4.64502 22.3889",
    stroke: "#A7C830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7984 2.96289V6.20363H20.5784",
    fill: "#A7C830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96094 23.9444V20.7036H6.18095",
    fill: "#A7C830"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyArrows);
export default __webpack_public_path__ + "static/media/money-arrows.97c7487ba0978bc7d6826ba63e13aeae.svg";
export { ForwardRef as ReactComponent };